import { useBusinessCardStore } from '@shared/store';
import { getQueryString } from '@shared/utils';
import { Dialog } from 'vant';
import { h } from 'vue';
import QrCode from '../components/qr-code/index.vue';
import { piTaskId } from './card';

export const useWechat = () => {
  const objId = getQueryString('objId');
  const cardStore = useBusinessCardStore();

  const clickWechat = async (e: MouseEvent) => {
    e.stopPropagation();
    _jt_.sendTracker({
      event_type: 'popup_window',
      block_desc: 'qr_code',
      button_desc: 'enter_btn',
      parameters: { objId: objId, pi_task_id: piTaskId.value },
    });

    await cardStore.drawQrCode();
    if (cardStore.drawQrCodeUrl) {
      Dialog({
        message: () => h(QrCode, { objId: objId as string, qrCodeUrl: cardStore.drawQrCodeUrl }),
        allowHtml: true,
        showConfirmButton: false,
        closeOnClickOverlay: true,
        className: 'popDialog',
      });
    }
  };

  return {
    clickWechat,
  };
};
